export const VERSION = '4.74.0'; // x-release-please-version
//# sourceMappingURL=version.mjs.map